import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {FullScreenSpinner} from "../components/exports";
import {getAuthManager} from "../utils/auth";

export default function Callback() {
    const query = new URLSearchParams(window.location.search);
    const navigate = useNavigate();

    useEffect(() => {
        const code = query.get("code");
        const auth = getAuthManager();
        auth.completeAuthentication(code, () => {
            const redirectUrl = localStorage.getItem("redirect-url") ?? "/";
            localStorage.removeItem("redirect-url");
            navigate(redirectUrl);
        }, (err) => {
            navigate("/login");
        });
    });

    return <FullScreenSpinner/>;
}
